import { render } from "./CreateLiveIg.vue?vue&type=template&id=7905dd6a"
import script from "./CreateLiveIg.vue?vue&type=script&lang=js"
export * from "./CreateLiveIg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__